module.exports = __webpack_public_path__ + "img/11172.c80c3c0d.jpg";